import { User } from '../User';

export const offlineUser: User = {
  tagIdsInPreferredOrder: ['uuid-612312', 'uuid-9898'],
  extraFeatures: ['periods'],
  preferences: {
    openMobileAddByDefault: true,
    currencyCode: 'USD',
  },
};
